import React from "react"
import { ButtonBase } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { AppValueChip } from "@components"
import { dsColorNew } from "@palette"


// A value added in the drawer (season, duration, range) as the app's soft chip, with its × to take it out again
export default function RemovableValueChip({ label, onDelete }) {
	return <AppValueChip>
		{label}
		<ButtonBase
			aria-label="Remove"
			onClick={onDelete}
			sx={{ borderRadius: '4px', color: dsColorNew.textSubtle, '&:hover': { color: dsColorNew.dangerRed } }}
		>
			<IconSeeker icon="xmark" sx={{ fontSize: 11 }}/>
		</ButtonBase>
	</AppValueChip>
}
